import * as types from '../mutation/mutation-types';
import { app } from '../../main';

const getters = {
  uid: state => state.uid,
  userName: state => state.userName,
  operatorId: state => state.operatorId,
  lastLogin: state => state.lastLogin,
  isLogin: state => state.isLogin,
  jwt: state => state.jwt,
  roles: state => state.roles
};

const mutations = {
  doLogin(state, payload) {
    state.uid = payload.uid;
    state.userName = payload.userName;
    state.operatorId = '';
    state.roles = payload.roles;
    state.lastLogin = '2018/9/12 10:55:21(sample)';
    state.isLogin = true;
  },
  doLogout(state) {
    state.isLogin = false;
  },
  saveJwt(state, payload) {
    state.jwt = payload;
  },
  reset(state) {
    state.userName = '';
    state.lastLogin = '';
    state.isLogin = false;
    state.jwt = '';
    state.roles = [];
  },
  [types.SET_LANG](state, payload) {
    app.$i18n.locale = payload;
  },
  setLang(state, payload) {
    state.lang = payload;
    // commit(types.SET_LANG, payload);
  },
  async setLangNew(state, payload) {
    console.log(909999, payload);
    if (payload in app.$i18n.messages) {
      app.$i18n.locale = payload;
    } else {
      try {
        // const res = await axios.get(`./src/lang/${payload}.json`)
        // const res = await axios.get(`../../src/lang/${payload}.json`)
        const res = await import(`../../locales/${payload}.json`);
        app.$i18n.setLocaleMessage(payload, res.data);
        app.$i18n.locale = payload;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
//
// const actions = {
//   setLang({ commit }, payload) {
//     commit(types.SET_LANG, payload);
//   },
//   async setLangNew({ commit }, payload) {
//     if (payload in app.$i18n.messages) {
//       commit(types.SET_LANG, payload);
//     } else {
//       try {
//         // const res = await axios.get(`./src/lang/${payload}.json`)
//         // const res = await axios.get(`../../src/lang/${payload}.json`)
//         const res = await import(`./src/lang/locale/${payload}.json`);
//         app.$i18n.setLocaleMessage(payload, res.data);
//         commit(types.SET_LANG, payload);
//       } catch (e) {
//         console.log(e);
//       }
//     }
//   }
// };

const state = {
  uid: '',
  userName: '',
  operatorId: '',
  lastLogin: '',
  isLogin: false,
  jwt: '',
  roles: [],
  lang: 'en'
};

export default {
  state,
  getters,
  mutations
  // actions
};
